module.exports = __webpack_public_path__ + "img/thumbnail-header-7.050f1d3.jpeg";